// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#page{width:100%}#page.page-fill-height{height:100%;padding:0;margin:0}#page .pageLayout{height:auto!important}#page .initPnl{height:70%}#page .pageError{max-width:700px}#page .pageError .pageErrorTitle{text-align:center}#page .pageError .pageErrorMsg{padding-left:15px}#page .pageAction,#page .pageAction .actionBlock,#page .pageTitle{display:inline-block}", ""]);
// Exports
module.exports = exports;
